/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsForwardLinkRequest
 */
export interface ControlcenterMelcoControlCenterModelsForwardLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsForwardLinkRequest
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsForwardLinkRequest
     */
    target_url?: string | null;
}

export function ControlcenterMelcoControlCenterModelsForwardLinkRequestFromJSON(json: any): ControlcenterMelcoControlCenterModelsForwardLinkRequest {
    return ControlcenterMelcoControlCenterModelsForwardLinkRequestFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsForwardLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsForwardLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'target_url': !exists(json, 'target_url') ? undefined : json['target_url'],
    };
}

export function ControlcenterMelcoControlCenterModelsForwardLinkRequestToJSON(value?: ControlcenterMelcoControlCenterModelsForwardLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'target_url': value.target_url,
    };
}


